import React from 'react';
import whatsappIcon from '../Images/WhatsApp_Image_2025-05-27_at_11.55.41_fe3dd58f-removebg-preview.png'; 

const WhatsAppButton = ({phoneNumber,textMessge}) => {

  const openWhatsApp = () => {
    const isMobile = /iPhone|Android|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const encodedText = encodeURIComponent(textMessge);
    const link = isMobile
      ? `https://wa.me/${phoneNumber}?text=${encodedText}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedText}`;

    // Create an <a> element and simulate a click
    const a = document.createElement('a');
    a.href = link;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
  };

  const buttonStyle = {
    position: 'fixed',
  bottom: '20px',
  right: '20px',
  width: '100px',        
  height: '100px',       
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
  zIndex: 1000,
  cursor: 'pointer'
  };

  const iconStyle = {
    width: '100%',         // image slightly smaller than container
  height: '100%',
  borderRadius: '50%',
  };

  return (
    <div onClick={openWhatsApp} style={buttonStyle}>
      <img
        src={whatsappIcon}
        alt="WhatsApp"
        style={iconStyle}
      />
    </div>
  );
};

export default WhatsAppButton;
